import React from "react";
import { FieldSet } from "src/components/event_transaction/components/shared/Form/FieldSet";
import { groupOptionScope1 } from "./groupOptionData";

const CheckBoxListsScope1 = (props) => {
  const { control, disabled } = props;

  return (
    <div>
      <FieldSet
        disabled={disabled}
        name="scopes.scope1"
        type="checkbox"
        control={control}
        label="Scope 1"
        subLabel="การเติมน้ำมัน"
        groupOptions={groupOptionScope1}
      />
    </div>
  );
};

export default CheckBoxListsScope1;
